import script from "./SavingIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./SavingIndicator.vue?vue&type=script&setup=true&lang=js"

import "./SavingIndicator.vue?vue&type=style&index=0&id=793b3040&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-793b3040"]])

export default __exports__